module.exports = __webpack_public_path__ + "img/gsb7.fdf27de6.png";